import z from "zod";
import { AddressSchema } from "./Address";

export const OrganisationSchema = z.object({
  id: z.string(),
  ownerId: z.string(),
  members: z.array(z.string()).optional().nullable(),
  permissableLocationIds: z.array(z.string()).optional(),
  memberCount: z.number().optional().nullable(),
  name: z.string(),
  active: z.boolean(),
  avatar: z.string().optional().nullable(),
  address: AddressSchema.optional().nullable(),
  officernd: z
    .object({
      companyId: z.string(),
      syncedAt: z.string(),
    })
    .optional()
    .nullable(),
  createdAt: z.union([z.string(), z.coerce.string()]), // ISO date string or Date object
  updatedAt: z.union([z.string(), z.coerce.string()]), // ISO date string or Date object
});

export type Organisation = z.infer<typeof OrganisationSchema>;

// export type Organisation = {
//   id: string;
//   name: string;
//   active: boolean;
//   avatar?: string;
//   address?: Address;
//   createdAt: Date;
//   updatedAt: Date;
// };

export interface OrganisationFilters {
  // ids
  organisationId?: string;
  searchTerm?: string;
  ownerId?: string;
}

export interface OrganisationSort {
  field: "name" | "active" | "memberCount";
  order: "asc" | "desc";
}
